import { ColorDynamic } from '@superdispatch/ui';
import styled from 'styled-components';

export const KeyboardShortcutBadge = styled.div`
  display: flex;
  align-items: center;
  min-width: 24px;
  height: 24px;
  background-color: ${ColorDynamic.White40};
  border: 1px solid ${ColorDynamic.White20};
  border-radius: 4px;
  padding-left: 4px;
  padding-right: 4px;
  justify-content: center;
`;
